/** US currency display — two decimals, avoids float artifacts in UI. */
export function formatMoney(value: number): string {
  return value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatMoneyFromCents(cents: number): string {
  return `$${formatMoney(cents / 100)}`;
}
